import _ from 'lodash';
import { CRUISE_PAY_SCHEDULE_FINAL_PAY, TravelTypes } from '../constants';

const formatCruisePayments = (tripConfirmation) => {
  if (tripConfirmation && tripConfirmation.bookingResponses) {
    const cruiseBookings = _.filter(tripConfirmation.bookingResponses,
      (b) => b.mode === TravelTypes.cruise && b.paidAmount > 0);
    if (tripConfirmation.trip.cruiseTotalPaymentAmount > 0
      && cruiseBookings && cruiseBookings.length) {
      return _.map(cruiseBookings,
        (b) => {
          let paymentAmount = b.paidAmount;
          const cruiseSeg = _.find(tripConfirmation.trip.tripSegments,
            (t) => t.mode === TravelTypes.cruise);
          if (cruiseSeg && cruiseSeg.itinerary && cruiseSeg.itinerary.cabins
              && cruiseSeg.itinerary.cabins[b.roomIndex]) {
            const finalPayment = cruiseSeg.itinerary.cabins[b.roomIndex].pricing.paymentSchedule
            && cruiseSeg.itinerary.cabins[b.roomIndex].pricing.paymentSchedule
              .find((l) => l.title === CRUISE_PAY_SCHEDULE_FINAL_PAY);
            if (finalPayment) {
              paymentAmount = +(+finalPayment.amount - paymentAmount).toFixed(2);
            }
          }
          return {
            paymentAmount, roomIndex: b.roomIndex,
          };
        });
    }
  }
  return [];
};

export default formatCruisePayments;
